/* Aflairza: full-screen product image viewer with zoom (desktop click / mobile double-tap) */
(function () {
  if (window.__afLightbox) return;
  window.__afLightbox = true;

  var css = '' +
    '.af-gallery__slide img{cursor:zoom-in}' +
    '.af-lb{position:fixed;inset:0;z-index:2147483647;background:#fbf8f4;display:flex;flex-direction:column;opacity:0;visibility:hidden;transition:opacity .25s ease,visibility .25s ease;font-family:Poppins,"Helvetica Neue",Arial,sans-serif;color:#1d1d1b}' +
    '.af-lb.is-open{opacity:1;visibility:visible}' +
    '.af-lb__bar{position:absolute;top:0;left:0;right:0;display:flex;align-items:center;justify-content:space-between;padding:14px 16px;z-index:3;pointer-events:none}' +
    '.af-lb__count{font-size:13px;letter-spacing:.12em;background:rgba(255,255,255,.85);padding:7px 14px;border-radius:999px;pointer-events:auto}' +
    '.af-lb__close,.af-lb__nav{pointer-events:auto;display:inline-flex;align-items:center;justify-content:center;width:46px;height:46px;border-radius:50%;border:1px solid rgba(29,29,27,.14);background:#fff;color:#1d1d1b;cursor:pointer;box-shadow:0 6px 18px rgba(0,0,0,.08);transition:background .2s,color .2s,transform .2s;padding:0}' +
    '.af-lb__close:hover,.af-lb__nav:hover{background:#1d1d1b;color:#fff}' +
    '.af-lb__close svg,.af-lb__nav svg{width:20px;height:20px;stroke:currentColor;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}' +
    '.af-lb__track{flex:1;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;overscroll-behavior:contain}' +
    '.af-lb__track::-webkit-scrollbar{display:none}' +
    '.af-lb__track.is-locked{overflow:hidden}' +
    '.af-lb__slide{flex:0 0 100%;height:100%;scroll-snap-align:center;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:72px 16px 64px;box-sizing:border-box}' +
    '.af-lb__slide img{max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;border-radius:12px;cursor:zoom-in;transition:transform .3s ease;user-select:none;-webkit-user-drag:none;touch-action:pan-x}' +
    '.af-lb__slide img.is-zoomed{transform:scale(2.4);cursor:zoom-out;border-radius:0;transition:transform .3s ease,transform-origin 0s;touch-action:none}' +
    '.af-lb__nav{position:absolute;top:50%;transform:translateY(-50%);z-index:3}' +
    '.af-lb__nav--prev{left:20px}.af-lb__nav--next{right:20px}' +
    '.af-lb__nav[disabled]{opacity:.3;pointer-events:none}' +
    '.af-lb__hint{position:absolute;left:0;right:0;bottom:18px;text-align:center;font-size:12px;letter-spacing:.14em;text-transform:uppercase;color:#6f6a64;pointer-events:none}' +
    '.af-lb__dots{position:absolute;left:0;right:0;bottom:44px;display:flex;justify-content:center;gap:7px;pointer-events:none}' +
    '.af-lb__dots span{width:7px;height:7px;border-radius:50%;background:rgba(29,29,27,.22);transition:background .2s,width .2s}' +
    '.af-lb__dots span.is-active{background:#1d1d1b;width:20px;border-radius:4px}' +
    '@media (max-width:989px){.af-lb__nav{width:40px;height:40px;background:rgba(255,255,255,.92);box-shadow:0 4px 14px rgba(0,0,0,.12)}.af-lb__nav svg{width:18px;height:18px}.af-lb__nav--prev{left:10px}.af-lb__nav--next{right:10px}.af-lb__nav:hover{background:rgba(255,255,255,.92);color:#1d1d1b}.af-lb__slide{padding:68px 0 70px}.af-lb__slide img{border-radius:0}}' +
    'html.af-lb-open,html.af-lb-open body{overflow:hidden!important}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var ICON_X = '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_L = '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>';
  var ICON_R = '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>';
  var touch = window.matchMedia('(hover: none)').matches;

  var lb, track, count, dots, prev, next, urls = [], idx = 0, pushed = false;

  function build() {
    lb = document.createElement('div');
    lb.className = 'af-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.innerHTML =
      '<div class="af-lb__bar"><span class="af-lb__count"></span>' +
      '<button type="button" class="af-lb__close" aria-label="Close">' + ICON_X + '</button></div>' +
      '<div class="af-lb__track"></div>' +
      '<button type="button" class="af-lb__nav af-lb__nav--prev" aria-label="Previous image">' + ICON_L + '</button>' +
      '<button type="button" class="af-lb__nav af-lb__nav--next" aria-label="Next image">' + ICON_R + '</button>' +
      '<div class="af-lb__dots"></div>' +
      '<div class="af-lb__hint">' + (touch ? 'Double-tap to zoom &middot; swipe or use arrows' : 'Click image to zoom') + '</div>';
    document.body.appendChild(lb);
    track = lb.querySelector('.af-lb__track');
    count = lb.querySelector('.af-lb__count');
    dots = lb.querySelector('.af-lb__dots');
    prev = lb.querySelector('.af-lb__nav--prev');
    next = lb.querySelector('.af-lb__nav--next');

    lb.querySelector('.af-lb__close').addEventListener('click', function () { close(); });
    prev.addEventListener('click', function () { go(idx - 1); });
    next.addEventListener('click', function () { go(idx + 1); });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      if (i !== idx) { unzoomAll(); idx = i; ui(); }
    }, { passive: true });
    /* Tap on empty space around the picture closes */
    track.addEventListener('click', function (e) {
      if (e.target.classList && e.target.classList.contains('af-lb__slide')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(idx - 1);
      else if (e.key === 'ArrowRight') go(idx + 1);
    });
    window.addEventListener('popstate', function () {
      if (lb.classList.contains('is-open')) { pushed = false; close(true); }
    });
  }

  function setOrigin(img, x, y) {
    var r = img.getBoundingClientRect();
    var px = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
    var py = Math.max(0, Math.min(100, ((y - r.top) / r.height) * 100));
    img.style.transformOrigin = px + '% ' + py + '%';
  }
  function unzoomAll() {
    Array.prototype.forEach.call(track.querySelectorAll('img.is-zoomed'), function (im) { im.classList.remove('is-zoomed'); });
    track.classList.remove('is-locked');
  }
  function toggleZoom(img, x, y) {
    if (img.classList.contains('is-zoomed')) { unzoomAll(); return; }
    unzoomAll();
    setOrigin(img, x, y);
    img.classList.add('is-zoomed');
    track.classList.add('is-locked');
  }

  function wire(img) {
    if (!touch) {
      img.addEventListener('click', function (e) { e.stopPropagation(); toggleZoom(img, e.clientX, e.clientY); });
      /* Recompute the zoom origin from the un-zoomed box so panning follows the cursor */
      img.addEventListener('mousemove', function (e) {
        if (!img.classList.contains('is-zoomed')) return;
        var r = img.parentElement.getBoundingClientRect();
        var px = Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100));
        var py = Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100));
        img.style.transformOrigin = px + '% ' + py + '%';
      });
    } else {
      var lastTap = 0, sx = 0, sy = 0, ox = 50, oy = 50;
      img.addEventListener('touchend', function (e) {
        if (e.changedTouches.length !== 1) return;
        var t = e.changedTouches[0], now = Date.now();
        if (now - lastTap < 300) {
          e.preventDefault();
          toggleZoom(img, t.clientX, t.clientY);
          lastTap = 0;
        } else lastTap = now;
      });
      img.addEventListener('touchstart', function (e) {
        if (!img.classList.contains('is-zoomed') || e.touches.length !== 1) return;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
        var o = (img.style.transformOrigin || '50% 50%').split(' ');
        ox = parseFloat(o[0]) || 50; oy = parseFloat(o[1]) || 50;
      }, { passive: true });
      img.addEventListener('touchmove', function (e) {
        if (!img.classList.contains('is-zoomed') || e.touches.length !== 1) return;
        e.preventDefault();
        var r = img.parentElement.getBoundingClientRect();
        var dx = (e.touches[0].clientX - sx) / r.width * 100 / 1.4;
        var dy = (e.touches[0].clientY - sy) / r.height * 100 / 1.4;
        img.style.transformOrigin = Math.max(0, Math.min(100, ox - dx)) + '% ' + Math.max(0, Math.min(100, oy - dy)) + '%';
      }, { passive: false });
    }
  }

  function ui() {
    count.textContent = (idx + 1) + ' / ' + urls.length;
    prev.disabled = idx <= 0;
    next.disabled = idx >= urls.length - 1;
    Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === idx); });
    var showMulti = urls.length > 1;
    dots.style.display = showMulti ? '' : 'none';
    count.style.visibility = showMulti ? '' : 'hidden';
    if (!showMulti) { prev.style.display = 'none'; next.style.display = 'none'; } else { prev.style.display = ''; next.style.display = ''; }
  }
  function go(i, instant) {
    if (i < 0 || i >= urls.length) return;
    unzoomAll();
    idx = i;
    track.scrollTo({ left: track.clientWidth * i, behavior: instant ? 'auto' : 'smooth' });
    ui();
  }

  function open(list, start) {
    if (!lb) build();
    urls = list; idx = start;
    track.innerHTML = ''; dots.innerHTML = '';
    list.forEach(function (u, i) {
      var s = document.createElement('div');
      s.className = 'af-lb__slide';
      var im = document.createElement('img');
      im.src = u.src; im.alt = u.alt || ''; im.draggable = false;
      im.loading = Math.abs(i - start) < 2 ? 'eager' : 'lazy';
      s.appendChild(im);
      track.appendChild(s);
      wire(im);
      dots.appendChild(document.createElement('span'));
    });
    document.documentElement.classList.add('af-lb-open');
    lb.classList.add('is-open');
    requestAnimationFrame(function () { go(start, true); });
    if (!pushed) { try { history.pushState({ afLightbox: 1 }, ''); pushed = true; } catch (e) {} }
    lb.querySelector('.af-lb__close').focus({ preventScroll: true });
  }
  function close(fromPop) {
    if (!lb || !lb.classList.contains('is-open')) return;
    unzoomAll();
    lb.classList.remove('is-open');
    document.documentElement.classList.remove('af-lb-open');
    if (pushed && !fromPop) { pushed = false; try { history.back(); } catch (e) {} }
  }

  /* Open from the product gallery */
  document.addEventListener('click', function (e) {
    var img = e.target && e.target.closest && e.target.closest('.af-gallery__slide img');
    if (!img) return;
    var gal = img.closest('.af-gallery__track');
    if (!gal) return;
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.af-gallery__slide img'));
    var list = imgs.map(function (im) {
      var best = im.currentSrc || im.src;
      if (im.srcset) {
        var parts = im.srcset.split(',').map(function (p) { return p.trim().split(/\s+/); });
        parts.sort(function (a, b) { return (parseInt(b[1], 10) || 0) - (parseInt(a[1], 10) || 0); });
        if (parts[0] && parts[0][0]) best = parts[0][0];
      }
      best = best.replace(/([?&])width=\d+/, '$1width=2000');
      return { src: best, alt: im.alt };
    });
    e.preventDefault();
    open(list, Math.max(0, imgs.indexOf(img)));
  });
})();
